export default{
    "mediaaccesserrormessage": "It is not possible to access the camera and/or the microphone! <br>You are only as listener in this room!",
    "errortosavechat": "The chat cannot be saved in the Browser!",
    "chatfilesizetogreat": "The file size is to great, the max file size is 256kb!",
    "firebaseautherror": "Authentification erro to firebase!<br>Reload the page!",
    "You": "You",
    "yourmessage": "Your message...",
    "inviteotherwithlink": "Invite other with this link",
    "name": "Name",
    "microphone": "Microphone",
    "video": "Camera",
    "speaker": "Speaker",
    "chat": "Chat",
    "participant": "Participant",
    "settings": "Settings",
    "ok": "ok",
    "buildownvideochat": "Build your own Video Chat",
    "reportabug": "Report a bug",
    "createaroom": "Create a room",
    "create": "Create",
    "roomname": "Room name",
    "connect": "Connect...",
    "imprint": "Imprint",
    "privacy": "Privacy",
    "cannotstartcamera": "A camera cannot be accessed!",
    "cannotstartmicrophone": "A microphone cannot be accessed!",
    "search": "Search...",
    "nointernet": "No internet connection...",
    "soundeffects": "Sound effects",
    "yourname": "Your name",
    "starting": "Start",
    "fullscreenon": "Fullscreen on",
    "fullscreenoff": "Fullscreen off",
    "mute": "Mute",
    "sound off": "Sound off",
    "sound on": "Sound on"
}